import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, CheckCircle, XCircle, AlertCircle } from 'lucide-react';
import { StatusBadge } from './components/StatusBadge';
import { useAdminData } from '../contexts/AdminDataContext';
export function AdminBookings() {
  const {
    bookings,
    updateBookingStatus
  } = useAdminData();
  const [activeTab, setActiveTab] = useState('todas');
  const tabs = [{
    id: 'todas',
    label: 'Todas'
  }, {
    id: 'confirmed',
    label: 'Confirmadas'
  }, {
    id: 'cancelled',
    label: 'Canceladas'
  }, {
    id: 'no_show',
    label: 'No-show'
  }];
  const filteredBookings = activeTab === 'todas' ? bookings : bookings.filter(b => b.booking_status === activeTab);
  return <div className="space-y-6" data-id="element-66">
      <div data-id="element-67">
        <h1 className="font-display text-3xl font-bold text-earth mb-2" data-id="element-68">
          Reservas
        </h1>
        <p className="text-stone" data-id="element-69">
          Administra las reservas de tus alumnos y sus pagos.
        </p>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="bg-white rounded-2xl border border-mist shadow-sm overflow-hidden" data-id="element-70">
        <div className="p-4 border-b border-mist bg-sand/30 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-71">
          <div className="flex gap-2 overflow-x-auto w-full sm:w-auto pb-2 sm:pb-0 hide-scrollbar" data-id="element-72">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors ${activeTab === tab.id ? 'bg-earth text-cream' : 'bg-white text-stone border border-mist hover:bg-sand'}`} data-id="element-73">
                {tab.label}
              </button>)}
          </div>
          <div className="relative w-full sm:w-64" data-id="element-74">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-stone/50" size={16} data-id="element-75" />
            <input type="text" placeholder="Buscar alumno..." className="w-full pl-9 pr-4 py-2 border border-mist rounded-lg text-sm outline-none focus:border-sage focus:ring-2 focus:ring-sage/20" data-id="element-76" />
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-77">
          <table className="w-full text-sm text-left" data-id="element-78">
            <thead className="text-xs text-stone uppercase bg-sand/10 border-b border-mist" data-id="element-79">
              <tr data-id="element-80">
                <th className="px-6 py-4 font-semibold" data-id="element-81">Alumno</th>
                <th className="px-6 py-4 font-semibold" data-id="element-82">Clase</th>
                <th className="px-6 py-4 font-semibold" data-id="element-83">Fecha / Hora</th>
                <th className="px-6 py-4 font-semibold" data-id="element-84">Pago</th>
                <th className="px-6 py-4 font-semibold" data-id="element-85">Estado</th>
                <th className="px-6 py-4 font-semibold text-right" data-id="element-86">Acciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-mist" data-id="element-87">
              {filteredBookings.map(booking => <tr key={booking.id} className="hover:bg-sand/10 transition-colors" data-id="element-88">
                  <td className="px-6 py-4" data-id="element-89">
                    <div className="font-bold text-earth" data-id="element-90">
                      {booking.student_name}
                    </div>
                    <div className="text-stone text-xs" data-id="element-91">
                      {booking.student_email}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-92">
                    <div className="font-medium text-earth" data-id="element-93">
                      {booking.class_name}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-94">
                    <div className="text-earth" data-id="element-95">{booking.session_date}</div>
                    <div className="text-stone text-xs" data-id="element-96">
                      {booking.start_time}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-97">
                    <div className="flex flex-col items-start gap-1" data-id="element-98">
                      <span className="font-bold text-earth" data-id="element-99">
                        ${booking.amount_paid}
                      </span>
                      <StatusBadge status={booking.payment_status} data-id="element-100" />
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-101">
                    <StatusBadge status={booking.booking_status} data-id="element-102" />
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-103">
                    <div className="flex items-center justify-end gap-2" data-id="element-104">
                      <button onClick={() => updateBookingStatus(booking.id, 'attended')} className="p-2 text-stone hover:text-success hover:bg-success/10 rounded-lg transition-colors" title="Marcar Asistencia" data-id="element-105">
                        <CheckCircle size={18} data-id="element-106" />
                      </button>
                      <button onClick={() => updateBookingStatus(booking.id, 'no_show')} className="p-2 text-stone hover:text-warning hover:bg-warning/10 rounded-lg transition-colors" title="Marcar No-show" data-id="element-107">
                        <AlertCircle size={18} data-id="element-108" />
                      </button>
                      <button onClick={() => updateBookingStatus(booking.id, 'cancelled')} className="p-2 text-stone hover:text-error hover:bg-error/10 rounded-lg transition-colors" title="Cancelar Reserva" data-id="element-109">
                        <XCircle size={18} data-id="element-110" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>;
}